/**
 * @owner @Appboy/messaging-experience
 */
import { campaignRemoteLookupValidators } from "../.generated/campaignRemoteLookup";
import type { CampaignRemoteLookupProvider } from "../.generated/campaignRemoteLookup";

export const campaignProvider: CampaignRemoteLookupProvider = {
  mapItemToId: (item) => item.id,
  mapIdToString: (id) => id,
  // The backend searches on :name; campaigns can be unnamed, so fall back to "".
  mapItemToSearchString: (item) => item.name ?? "",
  validators: campaignRemoteLookupValidators,
};
